export class Score {
    score: number;

    constructor() {
        this.score = 0;
    }
}
